var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"display-2"},[_vm._v("\n    Page Not Found\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }